export default {
  Integer: 'Entero',
  Float: 'Doble',
  Date: 'Fecha',
  Time: 'Hora',
  DateTime: 'Fecha y Hora',
  String: 'Texto',
  Home: 'Ir al Inicio',
  close: 'Cerrar',
  comingsoon:
    'Pronto recibirá un correo con las instrucciones de recuperación de contraseña',
  available: 'Disponible',
  selected: 'Seleccionado',
  selectdate: 'Seleccione una Fecha',
  edit: 'Modificar',
  edit_element: 'Modificar Material',
  delete: 'Eliminar',
  print: 'Imprimir',
  pdf: 'Exportar a Pdf',
  xls: 'Exportar a Excel',
  relacion: 'Imprimir Relación',
  acta_redimensionamiento: 'Generar Acta de Redimensionamiento',
  lostserverconnection: 'Se perdión conexión con el servidor. Verificando...',
  ver: 'Ver Detalle',
  anho: 'Año',
  mes: 'Mes',
  fecha: 'Fecha',
  registros: 'Registros',
  mensaje: 'Ultimo Mensaje',
  savesuccessful: 'Datos guardados exitosamente',
  savefail: 'Error al guardar los datos',
  months: {
    m1: 'Enero',
    m2: 'Febrero',
    m3: 'Marzo',
    m4: 'Abril',
    m5: 'Mayo',
    m6: 'Junio',
    m7: 'Julio',
    m8: 'Agosto',
    m9: 'Septiembre',
    m10: 'Octubre',
    m11: 'Noviembre',
    m12: 'Diciembre'
  },
  qb: {
    matchType: 'Tipo Concordancia',
    matchTypeAll: 'AND',
    matchTypeAny: 'OR',
    addRule: 'Agregar Regla',
    removeRule: '&times;',
    addGroup: 'Agregar Grupo',
    removeGroup: '&times;',
    textInputPlaceholder: 'valor',
    equals: 'igual'
  },
  buscar: {
    pormaterial: 'Busqueda por Código de Material'
  },
  acre: {
    tabletitle: 'Acta de Redimensionamiento',
    acre_numero: 'Número',
    acre_fecha: 'Fecha',
    acre_anho: 'Año',
    acre_periodo: 'Periodo'
  },
  cotr: {
    anho: 'Año',
    mes: 'Periodo',
    fecha_rango_inicio: 'Fecha Inicio',
    fecha_rango_fin: 'Fecha Fin',
    fecha: 'Fecha',
    consecutivo: 'Consecutivo',
    luminaria_anterior: 'Luminaria Anterior',
    luminaria_nueva: 'Luminaria Nueva',
    tecnologia_anterior: 'Tecnologia Anterior',
    tecnologia_nueva: 'Tecnologia Nueva',
    potencia_anterior: 'Potencia Anterior',
    potencia_nueva: 'Potencia Nueva',
    direccion: 'Dirección',
    cantidad: 'Cantidad',
    tipo_obra: 'Tipo de Obra',
    tipo_obra_tipo: 'Tipo'
  },
  cobro: {
    acta_redimensionamiento: 'Generar Acta de Redimensionamiento',
    anexo_redimensionamiento: 'Generar Anexo de Redimensionamiento'
  },
  route: {
    role: {
      pqrs: 'PQRS',
      supervisor: 'SUPERVISOR',
      inventario: 'INVENTARIO',
      facturacion: 'FACTURACION',
      gerencia: 'GERENCIA',
      interventoria: 'INTERVENTORIA',
      auditoria: 'AUDITORIA',
      supcontra: 'SUPERV. CONTRATO',
      alcalde: 'ALCALDE',
      contralor: 'CONTRALORIA'
    },
    group: {
      operador: 'OPERADOR DELEGADO',
      administrador: 'Administración'
    },
    dashboard: 'Tablero',
    procesos: 'Procesos',
    reporte: 'Reporte Luminaria',
    reportecreate: 'Reporte Luminaria/ Nuevo Reporte',
    reporteedit: 'Reporte Luminaria/ Modificar Información Reporte',
    reporteedittags: 'Reporte Luminaria/ Modificar Información Reporte',
    reportereparar: 'Reporte Luminaria/ Reparar Datos Según Reportes',
    control: 'Inventario Control',
    controlgestion: 'Control Activos',
    controlgestioncreate: 'Crear Nuevo Control',
    controlgestionedit: 'Modificar Control',
    controleliminada: 'Control En Baja',
    controlconsultaporcodigo: 'Control por Código Material',
    controlhistoria: 'Historia Control',
    controlgeoposicionamiento: 'Geoposicionamiento',
    controlreporte: 'Reporte Control',
    controlreportecreate: 'Reporte Control / Nuevo Reporte',
    controlreporteedit: 'Reporte Control/ Modificar Información Reporte',
    controlreporteedittags: 'Reporte Control / Modificar Información Reporte',
    controlreportereparar: 'Reporte Control / Reparar Datos Según Reportes',
    canalizacion: 'Inventario Canalización',
    canalizaciongestion: 'Canalización Activos',
    canalizaciongestioncreate: 'Crear Nueva Canalización',
    canalizaciongestionedit: 'Modificar Canalización',
    canalizacioneliminada: 'Canalización En Baja',
    canalizacionconsultaporcodigo: 'Canalización por Código Material',
    canalizacionhistoria: 'Historia Canalización',
    canalizaciongeoposicionamiento: 'Geoposicionamiento',
    canalizacionreporte: 'Reporte Canalización',
    canalizacionreportecreate: 'Reporte Canalización / Nuevo Reporte',
    canalizacionreporteedit:
      'Reporte Canalización/ Modificar Información Reporte',
    canalizacionreporteedittags:
      'Reporte Canalización / Modificar Información Reporte',
    canalizacionreportereparar:
      'Reporte Canalización / Reparar Datos Según Reportes',
    poste: 'Inventario Postes',
    postegestion: 'Postes Activos',
    postegestioncreate: 'Crear Nuevo Poste',
    postegestionedit: 'Modificar Poste',
    posteeliminada: 'Postes En Baja',
    posteconsultaporcodigo: 'Poste por Código Material',
    postehistoria: 'Historia Postes',
    postegeoposicionamiento: 'Geoposicionamiento',
    postereporte: 'Reporte Postes',
    postereportecreate: 'Reporte Postes / Nuevo Reporte',
    postereporteedit: 'Reporte Postes/ Modificar Información Reporte',
    postereporteedittags: 'Reporte Postes / Modificar Información Reporte',
    postereportereparar: 'Reporte Postes / Reparar Datos Según Reportes',
    redes: 'Inventario Redes',
    redesgestion: 'Redes Activos',
    redesgestioncreate: 'Crear Nuevo Redes',
    redesgestionedit: 'Modificar Redes',
    redeseliminada: 'Redes En Baja',
    redesconsultaporcodigo: 'Poste por Código Material',
    redeshistoria: 'Historia Redes',
    redesgeoposicionamiento: 'Geoposicionamiento',
    redesreporte: 'Reporte Redes',
    redesreportecreate: 'Reporte Redes / Nuevo Reporte',
    redesreporteedit: 'Reporte Redes/ Modificar Información Reporte',
    redesreporteedittags: 'Reporte Redes / Modificar Información Reporte',
    redesreportereparar: 'Reporte Redes / Reparar Datos Según Reportes',
    transformadorgestion: 'Transformador Activos',
    transformadorgestioncreate: 'Crear Nuevo Transformador',
    transformadorgestionedit: 'Modificar Transformador',
    transformadoreliminada: 'Transformador Eliminados',
    transformadorconsultaporcodigo: 'Transformador por Código Material',
    transformadorhistoria: 'Historia Transformador',
    transformadorgeoposicionamiento: 'Geoposicionamiento',
    transformadorreporte: 'Reporte Transformador',
    transformadorreportecreate: 'Reporte Transformador / Nuevo Reporte',
    transformadorreporteedit:
      'Reporte Transformador/ Modificar Información Reporte',
    transformadorreporteedittags:
      'Reporte Transformador / Modificar Información Reporte',
    transformadorreportereparar:
      'Reporte Transformador / Reparar Datos Según Reportes',
    medidor: 'Inventario Medidor',
    medidorgestion: 'Medidor Activos',
    medidorgestioncreate: 'Crear Nuevo Medidor',
    medidorgestionedit: 'Modificar Medidor',
    medidoreliminada: 'Medidor Eliminados',
    medidorconsultaporcodigo: 'Medidor por Código Material',
    medidorhistoria: 'Historia Medidor',
    medidorgeoposicionamiento: 'Geoposicionamiento',
    medidorreporte: 'Reporte Medidor',
    medidorreportecreate: 'Reporte Medidor / Nuevo Reporte',
    medidorreporteedit: 'Reporte Medidor/ Modificar Información Reporte',
    medidorreporteedittags: 'Reporte Medidor / Modificar Información Reporte',
    medidorreportereparar: 'Reporte Medidor / Reparar Datos Según Reportes',
    obra: 'Obra',
    obracreate: 'Obra / Nueva Obra',
    obraedit: 'Obra / Modificar Información Obra',
    obrarelacion: 'Relación Obras Pendientes',
    buscarpormaterial: 'Buscar Luminaria por Material',
    subreporte: 'SubReporte',
    subreportecreate: 'SubReporte / Nuevo SubReporte',
    subreporteedit: 'SubReporte / Modificar Información SubReporte',
    reporterelacion: 'Relación Reportes Pendientes',
    controlreporterelacion: 'Reportes Control Pendientes',
    reporteformato: 'Impresión Formato en Blanco',
    ordentrabajo: 'Orden de Trabajo',
    ordentrabajocreate: 'Orden de Trabajo / Nueva Orden de Trabajo',
    ordentrabajoedit: 'Orden de Trabajo / Modificar Orden de Trabajo',
    municipioobra: 'Municipio Obra',
    muobcreate: 'Municipio Obra / Nueva Obra',
    muobedit: 'Municipio Obra / Modificar Obra',
    muobinfo: 'Municipio Obra / Informe de Materiales',
    entregamaterial: 'Entrega de Material',
    recepcionmaterial: 'Recepción de Material',
    solicitud: 'Solicitud',
    solicitudlista: 'Solicitudes',
    solicitudcreate: 'Nuevo Derecho de Petición',
    solicitudedit: 'Actualizar Información de La Solicitud',
    solicitudalmacen: 'Asignar Puesto a Solicitud',
    solicitudporvencer: 'Solicitudes por Vencer',
    solicitudver: 'Ver Solicitud',
    solicitudinformexls: 'Informe Detallado Solicitud',
    solicitudinformexvencerxls: 'Informe Solicitud por Vencer',
    informe: 'Informes',
    rmaterial: 'Consolidado Material Utilizado',
    rmaterepo: 'Consolidado Por Tipo Reporte',
    rmaterepodet: 'Detallado Material Utilizado',
    rdetalladoexpansion: 'Detallado Expansión',
    rinventario: 'Inventario General',
    rdisponibilidad: 'Informe de Disponibilidad',
    reficiencia: 'Informe de Eficiencia',
    rdetalladoreubicacion: 'Detallado Reubicación',
    rdetalladomodernizacion: 'Detallado Modernización',
    rdetalladoactualizacion: 'Detallado Actualización',
    rdetalladoreposicion: 'Detallado Reposición',
    rdetalladorepotenciacion: 'Detallado Repotenciación',
    rdetalladoretiro: 'Detallado Retiro',
    rdetalladoretiroreubicacion: 'Detallado Retiro Vs Reubicacion',
    rdetalladocambiomedida: 'Detallado Cambio Tipo Medida',
    rconsolidadoreportes: 'Consolidado de Reportes',
    rvisitaporbarrio: 'Visitas por Barrio',
    rmaterialrepetido: 'Informe Material Repetido',
    rgraficos: 'Gráficas',
    rcalculocarga: 'Informe Cálculo de Carga',
    rmedidores: 'Informe de Medidores',
    rtransformadores: 'Informe de Transformadores',
    rpostes: 'Informe de Postes',
    rredes: 'Informe de Redes',
    rucap: 'Informe Unidades Constructivas',
    rmuot: 'Informe Municipio Obra',
    inventario: 'Inventario Luminaria',
    gestion: 'Luminarias Activas',
    eliminada: 'Luminarias En Baja',
    gestioncreate: 'Luminarias / Nueva Luminaria',
    gestionedit: 'Luminarias / Modificar Información Luminaria',
    consultaporcodigo: 'Consultar Luminaria por Código',
    historia: 'Historial',
    geoposicionamiento: 'Geoposicionamiento',
    administracion: 'Administrativos',
    caracteristica: 'Característica',
    caracteristicacreate: 'Característica / Nueva Característica',
    caracteristicaedit: 'Característica / Editar Característica',
    tipoelemento: 'Tipo de Material',
    tipoelementocreate: 'Tipo de Material / Nuevo Tipo de Material',
    tipoelementoedit: 'Tipo de Material / Editar Tipo de Material',
    elemento: {
      elemento: 'Material',
      elementocreate: 'Material / Nuevo Material',
      elementoedit: 'Material / Editar Material',
      lista: 'Material / Lista',
      precio: 'Material / Precio'
    },
    manoobra: 'Mano de Obra',
    manoobracreate: 'Mano de Obra / Nuevo',
    manoobraedit: 'Mano de Obra / Editar',
    cuadrilla: 'Cuadrilla',
    cuadrillacreate: 'Cuadrilla / Nueva Cuadrilla',
    cuadrillaedit: 'Cuadrilla / Editar Cuadrilla',
    usuario: 'Usuario',
    usuariocreate: 'Usuario / Nuevo Usuario',
    usuarioedit: 'Usuario / Editar Usuario',
    unitario: 'Unitario',
    unidad: 'Unidad',
    unidadcreate: 'Unidad / Nueva Unidad',
    unidadedit: 'Unidad / Editar Unidad',
    ucap: 'Ucap',
    ucapcreate: 'Ucap / Nueva Ucap',
    ucapedit: 'Ucap / Editar Ucap',
    urba: 'Urbanizadora',
    urbacreate: 'Urbanizadora / Nueva Urbanizadora',
    urbaedit: 'Urbanizadora / Editar Urbanizadora',
    empresa: 'Empresa',
    empresacreate: 'Empresa / Nueva Empresa',
    empresaedit: 'Empresa / Editar Empresa',
    barrio: 'Barrio',
    barriocreate: 'Barrio / Nuevo Barrio',
    barrioedit: 'Barrio / Editar Barrio',
    vencido: 'Vencido',
    introduction: 'Introducción',
    documentation: 'Documentación',
    permission: 'Perfiles',
    icons: 'Iconos',
    components: 'Componentes',
    componentIndex: 'Introducción',
    tinymce: 'MiniEditor',
    markdown: 'Rebaja',
    jsonEditor: 'Editor JSON',
    dndList: 'Lista Dnd',
    splitPane: 'Panel de División',
    avatarUpload: 'Subir Avatar',
    dropzone: 'Zona Descenso',
    sticky: 'Pegajoso',
    countTo: 'ConteoA',
    componentMixin: 'Mixin',
    backToTop: 'Atrás Arriba',
    charts: 'Gráficas',
    keyboardChart: 'Gráficas de Teclado',
    lineChart: 'Gráfica de Línea',
    mixChart: 'Gráfica Mix',
    example: 'Ejemplo',
    Table: 'Tabla',
    dynamicTable: 'Tabla Dinámica',
    dragTable: 'Tabla Arrastrar',
    inlineEditTable: 'Edición en Línea',
    complexTable: 'Tabla Compleja',
    treeTable: 'Tabla Arbol',
    customTreeTable: 'Tabla Arbol Personalizada',
    tab: 'Tab',
    form: 'Formulario',
    createForm: 'Crear Formulario',
    editForm: 'Editar Formulario',
    errorPages: 'Páginas de Error',
    page401: '401',
    page404: '404',
    errorLog: 'Log de Error',
    excel: 'Excel',
    exportExcel: 'Exportar Excel',
    selectExcel: 'Exportar Seleccionado',
    uploadExcel: 'Cargar Excel',
    zip: 'Zip',
    exportZip: 'Exportar Zip',
    theme: 'Tema',
    clipboardDemo: 'Portapapeles',
    i18n: 'I18n',
    gerencia: 'Gerencia',
    grafica: 'Gráficas',
    reporteporuso: 'Informe por Uso',
    autorizacion: 'Código de Autorización',
    crearaap: 'Crear Luminaria / Control',
    recuperaraap: 'Recuperar Luminaria / Control',
    cargarreporte: 'Cargar Reporte',
    abrirreporte: 'Abrir Reporte',
    consultarautorizacion: 'Consultar Códigos',
    /* medidor: 'Medidor', */
    medidorcreate: 'Nuevo Medidor',
    medidoredit: 'Editar Medidor',
    transformador: 'Transformador',
    transformadorcreate: 'Nuevo Transformador',
    transformadoredit: 'Editar Transformador',
    ipp: {
      lista: 'Ipp / Ipc'
    },
    mano_obra: {
      title: 'Mano Obra',
      lista: 'Lista',
      precio: 'Precio'
    },
    mano_herramienta: {
      title: 'Transporte Herramienta',
      lista: 'Lista',
      precio: 'Precio'
    },
    // Bloque nuevo con sub menu
    menu_inventario: 'Inventario',
    menu_inventario_menu1luminaria: 'Luminaria',
    'menu_inventario_menu1luminaria_menu1-1activa': 'Activa',
    'menu_inventario_menu1luminaria_menu1-2enbaja': 'En Baja',
    'menu_inventario_menu1luminaria_menu1-3porcodigo': 'Buscar Por Código',
    'menu_inventario_menu1luminaria_menu1-4historia': 'Historial',
    'menu_inventario_menu1luminaria_menu1-5geo': 'Geoposicionamiento',
    'menu_inventario_menu1luminaria_menu1-6pormaterial': 'Buscar Por Material',
    menu_inventario_menu2control: 'Control',
    'menu_inventario_menu2control_menu2-1activa': 'Activo',
    'menu_inventario_menu2control_menu2-2enbaja': 'En Baja',
    menu_inventario_menu3canalizacion: 'Canalizacion',
    'menu_inventario_menu3canalizacion_menu3-1activa': 'Activo',
    'menu_inventario_menu3canalizacion_menu3-2enbaja': 'En Baja',
    menu_inventario_menu4poste: 'Poste',
    'menu_inventario_menu4poste_menu4-1activa': 'Activo',
    'menu_inventario_menu4poste_menu4-2enbaja': 'En Baja',
    menu_inventario_menu5redes: 'Redes',
    'menu_inventario_menu5redes_menu5-1activa': 'Activa',
    'menu_inventario_menu5redes_menu5-2enbaja': 'En Baja',
    menu_inventario_menu6transformador: 'Transformador',
    'menu_inventario_menu6transformador_menu6-1activa': 'Activo',
    'menu_inventario_menu6transformador_menu6-2enbaja': 'En Baja',
    menu_inventario_menu7medidor: 'Medidor',
    'menu_inventario_menu7medidor_menu7-1activa': 'Activo',
    'menu_inventario_menu7medidor_menu7-2enbaja': 'En Baja',
    'menu_inventario_menu7medidor_menu7-3carga': 'Cargar Lectura',
    menu_proceso: 'Proceso',
    menu_proceso_menu1reporte: 'Reporte',
    'menu_proceso_menu1reporte_menu1-1luminaria': 'Luminaria',
    'menu_proceso_menu1reporte_menu1-1luminaria_menu1-1-1list': 'Lista',
    'menu_proceso_menu1reporte_menu1-1luminaria_menu1-1-2create': 'Crear',
    'menu_proceso_menu1reporte_menu1-1luminaria_menu1-1-3edit': 'Actualizar',
    'menu_proceso_menu1reporte_menu1-1luminaria_menu1-1-4elemento':
      'Ajuste Material',
    'menu_proceso_menu1reporte_menu1-2control': 'Control',
    'menu_proceso_menu1reporte_menu1-2control_menu1-2-1list': 'Lista',
    'menu_proceso_menu1reporte_menu1-2control_menu1-2-2create': 'Crear',
    'menu_proceso_menu1reporte_menu1-2control_menu1-2-3edit': 'Actualizar',
    'menu_proceso_menu1reporte_menu1-3canalizacion': 'Canalización',
    'menu_proceso_menu1reporte_menu1-3canalizacion_menu1-3-1list': 'Lista',
    'menu_proceso_menu1reporte_menu1-3canalizacion_menu1-3-2create': 'Crear',
    'menu_proceso_menu1reporte_menu1-3canalizacion_menu1-3-3edit': 'Actualizar',
    'menu_proceso_menu1reporte_menu1-4poste': 'Poste',
    'menu_proceso_menu1reporte_menu1-4poste_menu1-4-1list': 'Lista',
    'menu_proceso_menu1reporte_menu1-4poste_menu1-4-2create': 'Crear',
    'menu_proceso_menu1reporte_menu1-4poste_menu1-4-3edit': 'Actualizar',
    'menu_proceso_menu1reporte_menu1-5redes': 'Redes',
    'menu_proceso_menu1reporte_menu1-5redes_menu1-5-1list': 'Lista',
    'menu_proceso_menu1reporte_menu1-5redes_menu1-5-2create': 'Crear',
    'menu_proceso_menu1reporte_menu1-5redes_menu1-5-3edit': 'Actualizar',
    'menu_proceso_menu1reporte_menu1-6transformador': 'Transformador',
    'menu_proceso_menu1reporte_menu1-6transformador_menu1-6-1list': 'Lista',
    'menu_proceso_menu1reporte_menu1-6transformador_menu1-6-2create': 'Crear',
    'menu_proceso_menu1reporte_menu1-6transformador_menu1-6-3edit':
      'Actualizar',
    'menu_proceso_menu1reporte_menu1-7medidor': 'Medidor',
    'menu_proceso_menu1reporte_menu1-7medidor_menu1-7-1list': 'Lista',
    'menu_proceso_menu1reporte_menu1-7medidor_menu1-7-2create': 'Crear',
    'menu_proceso_menu1reporte_menu1-7medidor_menu1-7-3edit': 'Actualizar',
    'menu_proceso_menu1reporte_menu1-99migracion': 'Migración Reporte',
    menu_proceso_menu2pendiente: 'Informe de Reportes',
    'menu_proceso_menu2pendiente_menu2-1pendiente': 'Pendientes',
    'menu_proceso_menu2pendiente_menu2-2ejecutado': 'Ejecutados',
    'menu_proceso_menu2pendiente_menu2-3informecambios': 'Cambios',
    menu_proceso_menu3obra: 'Obra',
    'menu_proceso_menu3obra_menu3-1list': 'Reporte',
    'menu_proceso_menu3obra_menu3-2create': 'Crear',
    'menu_proceso_menu3obra_menu3-3edit': 'Actualizar',
    'menu_proceso_menu3obra_menu3-4pendiente': 'Reporte Obra Pendiente',
    menu_proceso_menu4orden: 'Orden de Trabajo',
    'menu_proceso_menu4orden_menu4-1interna': 'Interna',
    'menu_proceso_menu4orden_menu4-1interna_menu4-1-1list': 'Lista',
    'menu_proceso_menu4orden_menu4-1interna_menu4-1-2create': 'Crear',
    'menu_proceso_menu4orden_menu4-1interna_menu4-1-3edit': 'Actualizar',
    'menu_proceso_menu4orden_menu4-2externa': 'Historica',
    'menu_proceso_menu4orden_menu4-2externa_menu4-2-1list': 'Lista',
    'menu_proceso_menu4orden_menu4-2externa_menu4-2-2create': 'Crear',
    'menu_proceso_menu4orden_menu4-2externa_menu4-2-3edit': 'Actualizar',
    'menu_proceso_menu4orden_menu4-2externa_menu4-2-4info': 'Material',
    'menu_proceso_menu4orden_menu4-3cobro': 'Cobranza',
    'menu_proceso_menu4orden_menu4-3cobro_menu4-3-1list': 'Cobro',
    'menu_proceso_menu4orden_menu4-3cobro_menu4-3-2factura': 'Factura',
    'menu_proceso_menu4orden_menu4-3cobro_menu4-3-3acta':
      'Acta de Redimensionamiento',
    'menu_proceso_menu4orden_menu4-3-1lis': 'Opciones',
    'menu_proceso_menu4orden_menu4-3-1list': 'Lista',
    'menu_proceso_menu4orden_menu4-3-2factura': 'Factura',
    'menu_proceso_menu4orden_menu4-3-3acta': 'Acta',
    menu_proceso_menu5formato: 'Formato en Blanco',
    menu_proceso_menu6recuperar: 'Recuperar Historial',
    menu_proceso_menu7actadesmonte: 'Acta de Desmonte',
    menu_proceso_menu8cuadrilla: 'Gestión Cuadrilla',
    menu_proceso_menu9cierre: 'Cierre Reporte',
    'menu_proceso_menu9cierre_menu9-1directo': 'Directo',
    menu_informe: 'Informe',
    menu_informe_menu1consolidado: 'Consolidado',
    'menu_informe_menu1consolidado_menu1-1material': 'Material Utilizado',
    'menu_informe_menu1consolidado_menu1-2portipo': 'Material por Bodega',
    'menu_informe_menu1consolidado_menu1-3reporte': 'De Reportes',
    'menu_informe_menu1consolidado_menu1-4cuadrilla': 'Por Cuadrilla',
    'menu_informe_menu1consolidado_menu1-5operaciones': 'General Operaciones',
    'menu_informe_menu1consolidado_menu1-6estadistica': 'Estadística',
    'menu_informe_menu1consolidado_menu1-7aforo': 'Resumen Aforo',
    'menu_informe_menu1consolidado_menu1-8materialcuadrilla':
      'Material Por Cuadrilla',
    'menu_informe_menu1consolidado_menu1-9reportesinfoto': 'Reportes Sin Foto',
    'menu_informe_menu1consolidado_menu1-10materialusadoporreti':
      'Material Utilizado por Tipo',
    menu_informe_menu2detallado: 'Detallado',
    'menu_informe_menu2detallado_menu2-1material': 'Material',
    'menu_informe_menu2detallado_menu2-2expansion': 'Expansión',
    'menu_informe_menu2detallado_menu2-3reubicacion': 'Reubicación',
    'menu_informe_menu2detallado_menu2-4modernizacion': 'Modernización',
    'menu_informe_menu2detallado_menu2-5actualizacion': 'Actualización',
    'menu_informe_menu2detallado_menu2-6reposicion': 'Reposición',
    'menu_informe_menu2detallado_menu2-7repotenciacion': 'Repotenciación',
    'menu_informe_menu2detallado_menu2-8retiro': 'Retiro',
    'menu_informe_menu2detallado_menu2-9cambiomedida': 'Cambio de Medida',
    'menu_informe_menu2detallado_menu2-10retirovsreubicacion':
      'Retiro vs Reubicación',
    'menu_informe_menu2detallado_menu2-11porbarrio': 'Por Barrio',
    'menu_informe_menu2detallado_menu2-12repetido': 'Material Repetido',
    'menu_informe_menu2detallado_menu2-13cambiodireccion':
      'Cambio de Dirección',
    'menu_informe_menu2detallado_menu2-14luminariareporte':
      'Luminarias Por Reporte',
    'menu_informe_menu2detallado_menu2-15obracuadrilla': 'Cuadrilla Obra',
    'menu_informe_menu2detallado_menu2-16reportesinot': 'Reporte Sin O.T',
    menu_informe_menu3inventario: 'Inventario',
    'menu_informe_menu3inventario_menu3-1luminaria': 'Luminaria',
    'menu_informe_menu3inventario_menu3-2control': 'Control',
    'menu_informe_menu3inventario_menu3-3canalizacion': 'Canalización',
    'menu_informe_menu3inventario_menu3-4poste': 'Poste',
    'menu_informe_menu3inventario_menu3-5redes': 'Redes',
    'menu_informe_menu3inventario_menu3-6transformador': 'Transformador',
    'menu_informe_menu3inventario_menu3-7medidor': 'Medidor',
    menu_informe_menu4calculo: 'Indicadores',
    'menu_informe_menu4calculo_menu4-1disponibilidad': 'Disponibilidad',
    'menu_informe_menu4calculo_menu4-5indisponibilidad':
      'Acta Indisponibilidad',
    'menu_informe_menu4calculo_menu4-2carga': 'Carga',
    'menu_informe_menu4calculo_menu4-3eficiencia': 'Eficiencia',
    'menu_informe_menu4calculo_menu4-4ucap': 'Unidad Constructiva',
    menu_informe_menu5grafica: 'Gráfica',
    'menu_informe_menu5grafica_menu5-1operativa': 'Operativa',
    menu_informe_menu6foto: 'Fotográfico',
    menu_solicitud: 'Solicitud',
    menu_solicitud_menu1carta: 'Carta / Derecho',
    'menu_solicitud_menu1carta_menu1-1list': 'Lista',
    'menu_solicitud_menu1carta_menu1-2create': 'Crear',
    'menu_solicitud_menu1carta_menu1-3view': 'Ver',
    'menu_solicitud_menu1carta_menu1-4edit': 'Informe',
    menu_solicitud_menu2almacen: 'Asignar Consecutivo',
    menu_solicitud_menu3detallado: 'Informe Detallado',
    menu_solicitud_menu4porvencer: 'Informe por Vencer',
    menu_auditor: 'Auditoria',
    menu_auditor_menu1codigoautorizacion: 'Código Autorización',
    menu_acta_obra: 'Acta de Obra',
    menu_acta_obra_menu1list: 'Lista',
    menu_acta_obra_menu2create: 'Crear',
    menu_acta_obra_menu3edit: 'Modificar',
    menu_acta_obra_menu4item: 'Item Acta',
    svisor: 'Supervisor',
    geocuadrilla: 'Seguimiento'
  },
  navbar: {
    logOut: 'Cerrar Sesión',
    dashboard: 'Tablero',
    github: 'Github',
    screenfull: 'Pantalla Completa',
    theme: 'tema'
  },
  login: {
    name: 'Sistema Integral de Alumbrado Publico',
    title: 'Inicio de Sesión',
    logIn: 'Ingresar',
    username: 'Usuario',
    password: 'Contraseña',
    forgot: '¿Olvidó su Contraseña?',
    any: 'cualquier',
    thirdparty: 'O connectar con',
    thirdpartyTips:
      'No puede ser simulado en local, por favor combine su propia simulacón del negocio! ! !'
  },
  control: {
    gestion: {
      tabletitle: 'Control Activos',
      code: 'Código del Control',
      neighborhood: 'Barrio',
      neighborhoodtype: 'Sector',
      address: 'Dirección del Control',
      codes: 'Códigos'
    },
    eliminada: {
      tabletitle: 'Control En Baja'
    },
    reporte: {
      code: 'Código del Control',
      address: 'Dirección del Control'
    },
    historia: {
      title: 'Historia de Control'
    }
  },
  canalizacion: {
    gestion: {
      tabletitle: 'Canalización Activos',
      code: 'Código de la Canalización',
      neighborhood: 'Barrio',
      neighborhoodtype: 'Sector',
      address: 'Dirección de la Canalización',
      codes: 'Códigos'
    },
    eliminada: {
      tabletitle: 'Canalización En Baja'
    },
    reporte: {
      code: 'Código de la Canalización',
      address: 'Dirección de la Canalización'
    },
    historia: {
      title: 'Historia de Canalización'
    }
  },
  poste: {
    gestion: {
      tabletitle: 'Poste Activos',
      code: 'Código del Poste',
      neighborhood: 'Barrio',
      neighborhoodtype: 'Sector',
      address: 'Dirección del Poste',
      codes: 'Códigos'
    },
    eliminada: {
      tabletitle: 'Poste En Baja'
    },
    reporte: {
      code: 'Código del Poste',
      address: 'Dirección del Poste'
    },
    historia: {
      title: 'Historia del Poste'
    }
  },
  redes: {
    gestion: {
      tabletitle: 'Redes Activas',
      code: 'Código de la Red',
      neighborhood: 'Barrio',
      neighborhoodtype: 'Sector',
      address: 'Dirección de la Red',
      codes: 'Códigos'
    },
    eliminada: {
      tabletitle: 'Redes En Baja'
    },
    reporte: {
      code: 'Código de la Red',
      address: 'Dirección de la Red'
    },
    historia: {
      title: 'Historia de la Red'
    }
  },
  transformador: {
    gestion: {
      tabletitle: 'Transformador Activos',
      code: 'Código del Transformador',
      neighborhood: 'Barrio',
      neighborhoodtype: 'Sector',
      address: 'Dirección del Transformador',
      codes: 'Códigos'
    },
    reporte: {
      code: 'Código del Transformador',
      address: 'Dirección del Transformador'
    },
    historia: {
      title: 'Historia del Transformador'
    }
  },
  medidor: {
    gestion: {
      tabletitle: 'Medidores Activos',
      code: 'Código del Medidor',
      neighborhood: 'Barrio',
      neighborhoodtype: 'Sector',
      address: 'Dirección del Medidor',
      codes: 'Códigos'
    },
    eliminada: {
      tabletitle: 'Medidor En Baja'
    },
    reporte: {
      code: 'Código del Medidor',
      address: 'Dirección del Medidor'
    },
    historia: {
      title: 'Historia de Medidor'
    }
  },
  recovery: {
    title: 'Recuperar Contraseña',
    username: 'Digite la dirección de correo registrada en el sistema',
    send: 'Enviar Solicitud',
    error: 'Se requiere que digite la dirección de correo electrónico'
  },
  changepass: {
    title: 'Cambiar Contraseña',
    password: 'Digite la nueva contraseña',
    repassword: 'Vuelva a digitar la nueva contraseña',
    change: 'Enviar Solicitud'
  },
  empresa: {
    title: 'Empresas Disponibles',
    select: 'Seleccione la Empresa',
    submit: 'Seleccionar',
    description: 'Nombre de la Empresa',
    nit: 'Número de Identificación Tributaria (NIT)',
    address: 'Dirección de la Empresa',
    phone: 'Teléfono de la Empresa',
    sigla: 'Sigla',
    contract: 'Número de Contrato de Concesión',
    tabletitle: 'Empresas',
    departamento: 'Departamento de Ubicación de la Empresa',
    municipio: 'Municipio de Ubicación de la Empresa',
    barrio: 'Barrio',
    success: 'Éxito',
    created: 'Nueva Empresa Creada',
    error: 'Error',
    notcreated: 'No se pudo crear la nueva empresa, error =>',
    updated: 'Empresa actualizada con exito!',
    notupdated: 'Empresa no fue actualizada, error =>',
    confirmationmsg: 'Se procederá a borrar la Empresa seleccionada, continuar?'
  },
  elemento: {
    id: 'Id',
    title: 'Materiales Disponibles',
    select: 'Seleccione el Material',
    submit: 'Seleccionar',
    description: 'Descripción',
    characteristic: 'Característica',
    code: 'Código',
    address: 'Dirección',
    phone: 'Teléfono',
    ucap: 'Es UCAP',
    ucaptipo: 'Tipo de Ucap',
    tabletitle: 'Materiales',
    type: 'Tipo Material',
    success: 'Éxito',
    created: 'Nuevo Material Creado',
    error: 'Error',
    notcreated: 'No se pudo crear el nuevo elemento, error =>',
    updated: 'Material actualizado con exito!',
    notupdated: 'Material no fue actualizado, error =>',
    confirmationmsg:
      'Se procederá a borrar el Material seleccionado, continuar?',
    fecha: 'Fecha Soporte',
    bombillo: 'Bombillo',
    balasto: 'Balasto',
    arrancador: 'Arrancador',
    condensador: 'Condensador',
    fotocelda: 'Fotocelda',
    retirado: 'Retirado',
    instalado: 'Instalado',
    reporte: 'Reporte No.',
    reporte_tipo: 'Tipo Reporte',
    elpr_precio: 'Precio Favorable',
    elem_descripcion: 'Descripción',
    elem_codigo: 'Código',
    unitario: 'Ucap Unitario',
    date: 'Fecha Precio',
    elpr_anho_anterior: 'Año Anterior',
    elpr_incremento: 'Incremento',
    elpr_precio_anterior: 'Precio Anterior',
    elpr_anho: 'Año Actual',
    elpr_ipc: 'IPC Año',
    elpr_precio_nuevo: 'Precio Actual',
    elpr_precio_cotizado: 'Precio Cotizado',
    fecha_digitacion: 'Fecha Digitación',
    elpr_tipo_obra: 'Tipo Obra',
    elpr_tipo_obra_tipo: 'Nivel'
  },
  unitario: {
    select: 'Seleccione las Ucap',
    tabletitle: 'Unitarios',
    description: 'Descripción',
    code: 'Código',
    type: 'Tipo'
  },
  manoobra: {
    tabletitle: 'Mano de Obra',
    lista: 'Lista',
    precio: 'Precio',
    select: 'Seleccione la Mano de Obra',
    submit: 'Seleccionar',
    maob_descripcion: 'Descripción',
    maob_tipo: 'Tipo',
    mopr_precio: 'Precio',
    success: 'Éxito',
    created: 'Nueva Mano de Obra Creada',
    error: 'Error',
    notcreated: 'No se pudo crear la Mano de Obra, error =>',
    updated: 'Mano de Obra actualizada con exito!',
    notupdated: 'Mano de Obra no fue actualizada, error =>',
    confirmationmsg:
      'Se procederá a borrar la Mano de Obra seleccionada, continuar?'
  },
  mano_herramienta: {
    tabletitle: 'Transporte y Herramienta',
    select: 'Seleccione la Mano de Obra',
    submit: 'Seleccionar',
    math_descripcion: 'Descripción',
    math_codigo: 'Código',
    mathpr_anho_anterior: 'Año Anterior',
    mathpr_incremento: 'Incremento',
    mathpr_precio_anterior: 'Precio Anterior',
    mathpr_anho: 'Año Actual',
    math_tipo: 'Tipo',
    mathpr_precio: 'Precio',
    mathpr_es_porcentaje: 'Es Porcentaje',
    mathpr_rendimiento: 'Rendimiento',
    mathpr_cantidad: 'Cantidad',
    mathpr_fecha: 'Fecha',
    cotr_tipo_obra: 'Tipo Obra',
    cotr_tipo_obra_tipo: 'Nivel',
    success: 'Éxito',
    created: 'Nueva Mano de Obra Creada',
    error: 'Error',
    notcreated: 'No se pudo crear la Mano de Obra, error =>',
    updated: 'Mano de Obra actualizada con exito!',
    notupdated: 'Mano de Obra no fue actualizada, error =>',
    confirmationmsg:
      'Se procederá a borrar la Mano de Obra seleccionada, continuar?'
  },
  historia: {
    title: 'Historial de Luminarias',
    select: 'Seleccione la Luminaria',
    submit: 'Seleccionar',
    description: 'Descripción',
    characteristic: 'Característica',
    code: 'Código',
    support: 'Apoyo',
    address: 'Dirección',
    phone: 'Teléfono',
    ucap: 'Es UCAP',
    tabletitle: 'Materiales',
    type: 'Tipo Material',
    success: 'Éxito',
    created: 'Nuevo Material Creado',
    error: 'Error',
    notcreated: 'No se pudo crear el nuevo elemento, error =>',
    updated: 'Material actualizado con exito!',
    notupdated: 'Material no fue actualizado, error =>',
    confirmationmsg:
      'Se procederá a borrar el Material seleccionado, continuar?',
    fecha: 'Fecha Soporte',
    bombillo: 'Bombillo',
    balasto: 'Balasto',
    arrancador: 'Arrancador',
    condensador: 'Condensador',
    fotocelda: 'Fotocelda',
    retirado: 'Retirado',
    instalado: 'Instalado',
    reporte: 'Reporte No.',
    neighborhood: 'Barrio',
    neighborhoodtype: 'Tipo Sector',
    lat: 'Latitud',
    lng: 'Longitud',
    georeference: 'Coordenadas Georeferencia',
    connection: 'Tipo Medida'
  },
  accion: {
    select: 'Seleccione la Acción'
  },
  barrio: {
    select: 'Barrio',
    tabletitle: 'Barrios',
    description: 'Descripción',
    code: 'Código',
    departamento: 'Departamento',
    municipio: 'Municipio',
    type: 'Tipo Sector',
    success: 'Éxito',
    created: 'Nuevo Barrio Creado',
    error: 'Error',
    notcreated: 'No se pudo crear el nuevo barrio, error =>',
    updated: 'Barrio actualizado con exito!',
    notupdated: 'Barrio no fue actualizado, error =>',
    confirmationmsg: 'Se procederá a borrar el Barrio seleccionado, continuar?'
  },
  tipobarrio: {
    select: 'Seleccione el Tipo'
  },
  usuario: {
    title: 'Usuario',
    tabletitle: 'Usuario',
    lastname: 'Apellido',
    name: 'Nombre',
    email: 'Email',
    password: 'Contraseña',
    select: 'Seleccione el Usuario',
    success: 'Éxito',
    created: 'Nuevo Usuario Creado',
    error: 'Error',
    notcreated: 'No se pudo crear el nuevo usuario, error =>',
    updated: 'Usuario actualizado con exito!',
    notupdated: 'Usuario no fue actualizado, error =>',
    confirmationmsg: 'Se procederá a borrar al Usuario seleccionado, continuar?'
  },
  perfil: {
    title: 'Perfil',
    role: 'Perfil',
    select: 'Seleccione el Perfil'
  },
  departamento: {
    select: 'Seleccione el Departamento'
  },
  municipio: {
    select: 'Seleccione el Municipio'
  },
  unidad: {
    select: 'Seleccione la Unidad',
    submit: 'Seleccionar',
    description: 'Descripción',
    symbol: 'Símbolo',
    tabletitle: 'Unidades',
    success: 'Éxito',
    created: 'Nueva Unidad Creada',
    error: 'Error',
    notcreated: 'No se pudo crear la nueva unidad, error =>',
    updated: 'Unidad actualizada con exito!',
    notupdated: 'Unidad no fue actualizada, error =>',
    confirmationmsg: 'Se procederá a borrar la Unidad seleccionada, continuar?',
    type: 'Tipo Unidad',
    state: 'Estado'
  },
  ucap: {
    select: 'Seleccione la Ucap',
    submit: 'Seleccionar',
    description: 'Descripción',
    tabletitle: 'Ucap',
    success: 'Éxito',
    created: 'Nueva Ucap Creada',
    error: 'Error',
    notcreated: 'No se pudo crear la nueva ucap, error =>',
    updated: 'Ucap actualizada con exito!',
    notupdated: 'Ucap no fue actualizada, error =>',
    confirmationmsg: 'Se procederá a borrar la Ucap seleccionada, continuar?',
    state: 'Estado'
  },
  urba: {
    select: 'Seleccione la Urbanizadora',
    submit: 'Seleccionar',
    description: 'Descripción',
    tabletitle: 'Urbanizadora',
    success: 'Éxito',
    created: 'Nueva Urbanizadora Creada',
    error: 'Error',
    notcreated: 'No se pudo crear la nueva urbanizadora, error =>',
    updated: 'Urbanizadora actualizada con exito!',
    notupdated: 'Urbanizadora no fue actualizada, error =>',
    confirmationmsg:
      'Se procederá a borrar la Urbanizadora seleccionada, continuar?',
    state: 'Estado'
  },
  caracteristica: {
    select: 'Seleccione la Característica',
    submit: 'Seleccionar',
    description: 'Descripción',
    symbol: 'Unidad',
    tabletitle: 'Características',
    success: 'Éxito',
    created: 'Nueva Característica Creada',
    error: 'Error',
    notcreated: 'No se pudo crear la nueva característica, error =>',
    updated: 'Característica actualizada con exito!',
    notupdated: 'Característica no fue actualizada, error =>',
    confirmationmsg:
      'Se procederá a borrar la Característica seleccionada, continuar?',
    unit: 'Unidad',
    state: 'Estado',
    values: 'Posibles Valores',
    value: 'Valor',
    add: 'Agregar',
    fmtvalues: 'Por favor agregue los valores separados por coma (,)'
  },
  tipoelemento: {
    select: 'Seleccione el Tipo de Material',
    submit: 'Seleccionar',
    description: 'Descripción',
    symbol: 'Unidad',
    tabletitle: 'Tipos de Material',
    success: 'Éxito',
    created: 'Nueva Tipo de Material Creado',
    error: 'Error',
    notcreated: 'No se pudo crear el nuevo tipo de elemento, error =>',
    updated: 'Tipo de Material actualizado con exito!',
    notupdated: 'Tipo de Material no fue actualizado, error =>',
    confirmationmsg:
      'Se procederá a borrar el Tipo de Material seleccionado, continuar?',
    state: 'Estado',
    values: 'Posibles Valores',
    fmtvalues: 'Por favor agregue los valores separados por coma (,)'
  },
  cuadrilla: {
    select: 'Seleccione la Cuadrilla',
    submit: 'Seleccionar',
    description: 'Descripción',
    tabletitle: 'Cuadrillas',
    success: 'Éxito',
    created: 'Nueva Cuadrilla Creada',
    error: 'Error',
    notcreated: 'No se pudo crear la cuadrilla, error =>',
    updated: 'Cuadrilla actualizada con exito!',
    notupdated: 'Cuadrilla no fue actualizada, error =>',
    confirmationmsg:
      'Se procederá a borrar la cuadrilla seleccionada, continuar?',
    state: 'Estado'
  },
  operativo: {
    reporttitle: 'Reportes de Luminarias',
    controltitle: 'Reportes de Controles',
    canalizaciontitle: 'Reportes de Canalización',
    postetitle: 'Reportes de Postes',
    redestitle: 'Reportes de Redes',
    transformadortitle: 'Reportes de Transformadores',
    medidortitle: 'Reportes de Medidores',
    workordertitle: 'Orden de Trabajo',
    workordercobrotitle: 'Cobro Orden de Trabajo Municipio',
    obratitle: 'Obras',
    vencidotitle: 'Reportes Fuera de Fecha'
  },
  solicitud: {
    title: 'Derecho de Petición',
    ver: 'Ver Solicitud',
    tipo: 'Tipo Solicitud',
    number: 'Número',
    fecha: 'Fecha',
    fechalimite: 'Fecha Límite',
    radicado: 'Radicado',
    direccion: 'Dirección',
    nombre: 'Nombre Solicitante',
    barrio: 'Barrio',
    telefono: 'Teléfono',
    email: 'Correo Electrónico',
    estado: 'Estado',
    descripcion: 'Detalle de la Petición',
    fechasupervisor: 'Fecha Entrega a Supervisor',
    fecharte: 'Fecha Entrega Formato Reporte Técnico',
    fechaalmacen: 'Fecha Recibido en Almacén',
    fechainforme: 'Fecha Informe Técnico',
    fecharespuesta: 'Fecha Respuesta',
    fechaentrega: 'Fecha de Entrega de la Respuesta',
    fechavisita: 'Fecha Visita',
    numerorte: 'Puesto Reporte Técnico',
    codigorespuesta: 'Código Respuesta',
    respuesta: 'Detalle de la Respuesta',
    informe: 'Informe Técnico',
    asupervisor: 'Entregar a Supervisor',
    aformatorte: 'Entregar Formato Reporte Técnico',
    dinforme: 'Ingresar Informe Técnico',
    drespuesta: 'Respuesta',
    dentrega: 'Fecha Entrega Respuesta',
    porvencer: 'Solicitud Cercanas a su Fecha de Vencimiento',
    success: 'Éxito',
    created: 'Nueva Solicitud Creada',
    error: 'Error',
    notcreated: 'No se pudo crear la solicitud, error =>',
    updated: 'Solicitud actualizada con exito!',
    notupdated: 'Solicitud no fue actualizada, error =>',
    confirmationmsg:
      'Se procederá a borrar la solicitud seleccionada, continuar?',
    aprobado: 'Aprobado',
    tipo_expansion: {
      title: 'Tipo de Expansión',
      select: 'Seleccione el Tipo de Expansión'
    },
    tipo_modernizacion: {
      title: 'Tipo de Modernización',
      select: 'Seleccione el Tipo de Modernización'
    },
    numero_luminarias: 'Cantidad de Luminarias',
    puntos: 'Total Puntos'
  },
  muob: {
    tabletitle: 'Municipio Obra',
    muob_consecutivo: 'Consecutivo',
    muob_fecharecepcion: 'Fecha Recepción',
    muob_descripcion: 'Descripción Obra',
    muob_direccion: 'Dirección Obra',
    barr_descripcion: 'Barrio',
    general: 'Datos Generales',
    error: 'Error',
    notcreated: 'No se puedo crear la Municipio Obra, error =>',
    success: 'Éxito',
    created: 'Nueva Municipio Obra Creada',
    updated: 'Municipio Obra actualizada con exito!',
    notupdated: 'Municipio Obra no fue actualizada, error =>',
    confirmationmsg:
      'Se procederá a borrar la Municipio Obra seleccionada, continuar?'
  },
  reporte: {
    actaindisponibilidad: 'Acta Indisponibilidad',
    tipo: {
      select: 'Seleccione el Tipo de Reporte'
    },
    estado: {
      select: 'Seleccione el Estado del Reporte',
      title: 'Estado'
    },
    origen: {
      select: 'Seleccione el Origen del Reporte'
    },
    tipo_expansion: {
      title: 'Tipo de Expansión',
      select: 'Seleccione el Tipo de Expansión'
    },
    tipo_modernizacion: {
      title: 'Tipo Modernización',
      select: 'Seleccione el Tipo de Modernización'
    },
    duedate: {
      title: 'Fecha de los Reportes',
      select: 'Seleccione la Fecha a Procesar',
      procesar: 'Generar Reporte'
    },
    urba: {
      title: 'Urbanizadora',
      select: 'Seleccione la Urbanizadora'
    },
    subreporte: 'SUBREPORTES',
    formato: 'Impresión de Formato en Blanco',
    code: 'Código Luminaria',
    email: 'Correo electrónico de quién reporta',
    apoyo: 'Código de Apoyo',
    consec: 'Consecutivo',
    type: 'Tipo de Reporte',
    sector: 'Tipo de Sector',
    activity: 'Daño Reportado',
    origin: 'Origen del Reporte',
    address: 'Dirección de la Luminaria',
    neighborhood: 'Barrio en el que se reporta el daño o actividad',
    description: 'Descripción del Daño',
    principal: 'REPORTE PRIMARIO',
    general: 'DATOS GENERALES',
    inform: 'INFORME DE LA CUADRILLA',
    events: 'MATERIALES',
    event: 'Material',
    addresses: 'DIRECCIONES',
    name: 'Nombre de quién reporta',
    phone: 'Teléfono de quién reporta',
    receptiondate: 'Fecha Recepción',
    solutiondate: 'Fecha de Solución',
    tecnicalreport: 'Reporte Técnico',
    timestart: 'Hora de Inicio',
    timeend: 'Hora de Terminación',
    success: 'Éxito',
    created: 'Nuevo Reporte Creado',
    error: 'Error',
    notcreated: 'No se pudo crear el reporte, error =>',
    updated: 'Reporte actualizado con exito!',
    notupdated: 'Reporte no fue actualizado, error =>',
    confirmationmsg:
      'Se procederá a borrar el reporte seleccionado, continuar?',
    print: 'Imprimir',
    environment: 'Manejo del Medio Ambiente',
    status: 'Estado',
    add: 'Agregar',
    relacion: 'Reporte / Relación de Reportes Pendientes',
    date: 'Fecha',
    date_solve: 'Fecha Solución',
    number: 'Número',
    duetime: 'Fecha Límite',
    hour: 'Hora(s)',
    cuadrilla: 'Cuadrilla',
    ot: 'ODT Interna',
    otm: 'Municipio ODT',
    aaco_id_anterior: 'Tipo Medida Anterior',
    aaco_id_nuevo: 'Tipo Medida Nuevo',
    aap_fechatoma: 'Fecha Toma',
    reparar: 'Recuperar',
    novedades: 'Novedades',
    actadesmonte: 'Acta de Desmonte',
    fechaCorte: 'Fecha a Procesar',
    ejecutado: 'Informe de Reportes Ejecutados',
    fechaInicio: 'Fecha Inicial',
    fechaFinal: 'Fecha Final',
    orig_descripcion: 'Origen'
  },
  ortr: {
    select: 'Seleccione la ODT'
  },
  obra: {
    tipo: {
      select: 'Seleccione el Tipo de Obra'
    },
    estado: {
      select: 'Seleccione el Estado de la Obra'
    },
    origen: {
      select: 'Seleccione el Origen de la Obra'
    },
    tipo_expansion: {
      title: 'Tipo de Expansión',
      select: 'Seleccione el Tipo de Expansión'
    },
    duedate: {
      title: 'Fecha de las Obras',
      select: 'Seleccione la Fecha a Procesar',
      procesar: 'Generar Reporte'
    },
    formato: 'Impresión de Formato en Blanco',
    code: 'Código Luminaria',
    email: 'Correo electrónico Solicitante',
    consec: 'Consecutivo',
    type: 'Tipo de Obra',
    sector: 'Tipo de Sector',
    origin: 'Origen de la Obra',
    address: 'Dirección de la Obra',
    neighborhood: 'Barrio de la Obra',
    description: 'Descripción de la Obra',
    principal: 'DATOS PRIMARIO',
    general: 'DATOS GENERALES',
    inform: 'INFORME DE LA CUADRILLA',
    events: 'MATERIALES',
    event: 'Material',
    addresses: 'DIRECCIONES',
    receptiondate: 'Fecha Recepción',
    solutiondate: 'Fecha de Entrega',
    tecnicalreport: 'Reporte Técnico',
    success: 'Éxito',
    created: 'Nueva Obra Creada',
    error: 'Error',
    notcreated: 'No se pudo crear la obra, error =>',
    updated: 'Obra actualizada con exito!',
    notupdated: 'Obra no fue actualizada, error =>',
    confirmationmsg: 'Se procederá a borrar la obra seleccionada, continuar?',
    print: 'Imprimir',
    environment: 'Manejo del Medio Ambiente',
    status: 'Estado',
    add: 'Agregar',
    relacion: 'Obra / Relación de Obras Pendientes',
    date: 'Fecha',
    consecutivo: 'Consecutivo',
    timestart: 'Hora Inicio',
    timeend: 'Hora Fin',
    name: 'Nombre de la Obra',
    ot: 'ODT Interna',
    mot: 'Municipio OT',
    solicitante: 'Nombre Solicitante',
    telefono: 'Teléfono Solicitante'
  },
  factura: {
    tabletitle: 'Factura de Obra',
    numero: 'Número Factura',
    anho: 'Año',
    periodo: 'Periodo',
    fecha: 'Fecha',
    orden: 'Orden',
    consecutivo: 'Número Orden',
    confirmationmsg: 'Seguro de Eliminar la Factura No.'
  },
  estado: {
    select: 'Seleccione el Estado',
    title: 'Estado'
  },
  origen: {
    select: 'Seleccione el Origen'
  },
  actividad: {
    select: 'Seleccione el Daño'
  },
  eliminada: {
    tabletitle: 'Luminarias En Baja',
    success: 'Éxito',
    recoveredsuccessful: 'Luminaria recuperada con exito!',
    error: 'Error',
    recoveredfail: 'No se pudo recuperar la luminaria, error =>',
    confirmationmsg:
      'Se procederá a recuperar la luminaria seleccionada, continuar?',
    recovercancelled: 'Se canceló la recuperación de la luminaria'
  },
  gestion: {
    tabletitle: 'Gestión de Luminarias Activas',
    select: 'Seleccione el Activo',
    submit: 'Seleccionar',
    description: 'Descripción',
    code: 'Código Luminaria',
    codemini: 'Código',
    support: 'Código Apoyo',
    address: 'Dirección Luminaria',
    neighborhood: 'Barrio',
    vereda: 'Es Vereda',
    neighborhoodtype: 'Sector',
    lat: 'Latitud',
    lng: 'Longitud',
    georeference: 'Coodenadas Georeferencia',
    success: 'Éxito',
    created: 'Nuevo Activo Creado',
    error: 'Error',
    notcreated: 'No se pudo crear el nuevo activo, error =>',
    updated: 'Activo actualizado con exito!',
    notupdated: 'Activo no fue actualizado, error =>',
    confirmationmsg: 'Se procederá a borrar el Activo seleccionado, continuar?',
    state: 'Estado',
    gettime: 'Fecha de Toma',
    modern: 'Modernizada',
    modernyear: 'Año Modernizada',
    brand: 'Marca Luminaria',
    account: 'Cuenta Alumbrado',
    counter: 'Medidor',
    cover: 'Tipo de Luminaria',
    model: 'Modelo de Luminaria',
    use: 'Tipo de Uso',
    codes: 'Códigos',
    additional: 'Información Adicional',
    generals: 'Datos Generales',
    elements: 'Materiales',
    doesnotexist: 'El código de luminaria ingresado No Existe',
    tecnology: {
      select: 'Seleccione la Tecnología',
      title: 'Tecnología'
    },
    power: {
      select: 'Seleccione la Potencia',
      title: 'Potencia'
    },
    post: {
      title: 'Tipo de Poste',
      select: 'Seleccione el Tipo de Poste',
      size: 'Altura Poste',
      own: 'Propietario Poste',
      selectown: 'Seleccione el Propietario',
      numero: 'Código',
      direccion: 'Dirección del Poste',
      barr_descripcion: 'Barrio',
      cantidad: 'Cantidad Luminarias'
    },
    redes: {
      numero: 'Código',
      direccion: 'Dirección de la Red',
      barr_descripcion: 'Barrio',
      cantidad: 'Cantidad Luminarias'
    },
    connection: {
      select: 'Seleccione el Tipo de Medida',
      title: 'Tipo Medida'
    },
    medidor: {
      tabletitle: 'Medidores',
      select: 'Seleccione el Medidor',
      title: 'Medidor',
      codigo: 'Código',
      numero: 'Número',
      direccion: 'Dirección',
      barr_descripcion: 'Barrio',
      cantidad: 'Cantidad Luminarias',
      acta: 'Acta',
      tipo: {
        title: 'Tipo',
        select: 'Seleccione el Tipo de Medidor'
      },
      marca: {
        title: 'Marca',
        select: 'Seleccione la Marca del Medidor'
      },
      cuentaap: {
        title: 'Cuenta Alumbrado',
        select: 'Seleccione la Cuenta de Alumbrado'
      },
      success: 'Éxito',
      created: 'Medidor Creado',
      error: 'Error',
      notcreated: 'Medidor no fue creado',
      updated: 'Medidor Actualizado',
      notupdated: 'Medidor No Actualizado'
    },
    transformador: {
      code: 'Código',
      tabletitle: 'Transformador',
      select: 'Seleccione el Transformador',
      title: 'Transformador',
      numero: 'Número',
      direccion: 'Dirección',
      barr_descripcion: 'Barrio',
      cantidad: 'Cantidad Luminarias',
      confirmationmsg: 'Seguro de Eliminar el Transformador Número: ',
      success: 'Éxito',
      created: 'Transformador Creado',
      error: 'Error',
      notcreated: 'Transformador no fue creado',
      updated: 'Transformador Actualizado',
      notupdated: 'Transformador No Actualizado',
      tran_propietario: 'Propietario',
      tran_marca: 'Marca',
      tran_serial: 'Serial',
      tran_kva: 'KVA',
      tipo_id: 'Tipo Poste',
      tran_fases: 'Fases',
      tran_tension_p: 'Tensión Primaria',
      tran_tension_s: 'Tensión Secundaria',
      tran_referencia: 'Referencia',
      tran_codigo_apoyo: 'Código Apoyo'
    },
    arm: 'Brazo',
    collar: 'Collarin',
    rte: 'Reporte Técnico',
    bulb: 'Bombillo',
    ballast: 'Balasto',
    starter: 'Arrancador',
    condenser: 'Condensador',
    photocell: 'Fotocelda',
    report: 'No. Reporte',
    tiporetiro: 'Motivo Retiro',
    estado: 'Estado Luminaria'
  },
  evento: {
    element: 'Material',
    code: 'Código Inventario',
    codemini: 'Código',
    action: 'Acción',
    quantity: 'Cantidad',
    add: 'Agregar',
    number: 'Número'
  },
  ordentrabajo: {
    consecutive: 'Consecutivo',
    date: 'Fecha',
    crew: 'Cuadrilla',
    status: 'Estado',
    general: 'Datos Generales',
    type: 'Tipo de Sector',
    success: 'Éxito',
    created: 'Nueva Orden de Trabajo Creada',
    error: 'Error',
    notcreated: 'No se pudo crear la nueva orden de trabajo, error =>',
    updated: 'Orden de trabajo actualizada con exito!',
    notupdated: 'Orden de trabajo no fue actualizada, error =>',
    confirmationmsg:
      'Se procederá a borrar la Orden de trabajo seleccionada, continuar?',
    reports: 'Reportes',
    obras: 'Obras',
    novedades: 'Novedades',
    novedad: {
      select: 'Seleccione la Novedad'
    }
  },
  use: {
    select: 'Seleccione Uso de la Luminaria'
  },
  brand: {
    select: 'Seleccione Marca de Luminaria'
  },
  counter: {
    brand: {
      title: 'Marca',
      select: 'Seleccione la Marca del Medidor'
    },
    type: {
      title: 'Tipo',
      select: 'Seleccion el Tipo de Medidor'
    },
    number: 'Número'
  },
  cover: {
    select: 'Seleccione el Tipo Luminaria'
  },
  connection: {
    select: 'Seleccione Tipo de Medida'
  },
  account: {
    select: 'Seleccione la Cuenta Alumbrado'
  },
  model: {
    select: 'Seleccione el Modelo de la Luminaria'
  },
  tiporetiro: {
    select: 'Seleccione el Motivo del Retiro'
  },
  general: {
    warning: 'Advertencia',
    ok: 'Aceptar',
    cancel: 'Cancelar',
    error: 'Error',
    info: 'Información',
    deletesuccessful: 'Borrado completado con exito!',
    deletecancelled: 'Borrado cancelado!',
    deletefail: 'Hubo un error al tratar de realizar el Borrado!'
  },
  documentation: {
    documentation: 'Documentación',
    github: 'Repositorio Github'
  },
  informe: {
    scc: 'Informe Cálculo de Carga',
    srm: 'Consolidado Material Utilizado',
    smr: 'Informe Material Repetido',
    srmr: 'Consolidado Material por Bodega',
    sdm: 'Detallado Material Utilizado',
    sdmx: 'Detallado Modernización',
    sdax: 'Detallado Actualización',
    sdpx: 'Detallado Reposición',
    sdwx: 'Detallado Repotenciacion',
    sdtx: 'Detallado Retiro',
    sde: 'Detallado Expansión',
    sig: 'Inventario General',
    sdx: 'Informe de Disponibilidad',
    sex: 'Informe de Eficiencia',
    sucx: 'Informe de Unidades Constructivas',
    sdr: 'Detallado Reubicación',
    sdcm: 'Detallado Cambio Tipo de Medida',
    sdrr: 'Detallado Retiro vs Reubicación',
    sgr: 'Informes Gráficos',
    scr: 'Informe Consolidado de Reportes',
    svpb: 'Informe de Visitas por Barrio',
    srpu: 'Informe por Uso',
    smx: 'Informe de Medidores',
    stx: 'Informe de Transformadores',
    sisx: 'Informe de Solicitudes',
    sisvx: 'Informe Solicitud por Vencer',
    simox: 'Informe Municipio Orden de Trabajo',
    srx: 'Informe Redes',
    spx: 'Informe Postes',
    scdx: 'Informe Detallado de Cambios de Dirección Luminaria por Reporte',
    slprx: 'Informe de Luminarias Atendidas Por Reporte',
    sipcx: 'Informe Consolidado por Cuadrilla',
    sigox: 'Informe General de Operaciones',
    sigex: 'Informe General Estadístico',
    soprx: 'Informe Cuadrilla Obra',
    srsot: 'Informe Reporte Sin Orden de Trabajo',
    srax: 'Informe Resumen Aforo',
    srf: 'Fotográfico',
    srmupt: 'Material Utilizado por Tipo de Reporte',
    initialDate: 'Fecha Inicial',
    endDate: 'Fecha Final',
    dueDate: 'Fecha de Corte',
    process: 'Obtener Datos',
    elem_codigo: 'Código Material',
    elem_descripcion: 'Nombre Material',
    reti_descripcion: 'Tipo Reporte',
    repo_consecutivo: 'No. Reporte',
    even_codigo_retirado: 'Retirado',
    even_cantidad_retirado: 'Retirado',
    even_codigo_instalado: 'Instalado',
    even_cantidad_instalado: 'Instalado',
    cantidad: 'Cantidad',
    codigo: 'Código',
    retirado: 'Retirado',
    instalado: 'Instalado',
    repo_fechasolucion: 'Fecha Solución',
    aap_id: 'Código Luminaria',
    aap_apoyo: 'Apoyo',
    aap_codigo_reubicacion: 'Código Reubicación',
    aap_direccion_anterior: 'Dirección Anterior',
    barr_descripcion_anterior: 'Barrio Anterior',
    aap_direccion: 'Dirección',
    barr_descripcion: 'Barrio',
    aap_direccion_actual: 'Dirección Actual',
    barr_descripcion_actual: 'Barrio Actual',
    tiba_descripcion: 'Sector',
    aaus_descripcion: 'Uso',
    aap_modernizada: 'Modernizada',
    aap_modernizada_anho: 'Año Modernizada',
    aatc_descripcion: 'Tipo Luminaria',
    aap_medidor: 'Medidor',
    aaco_descripcion: 'Tipo Medida',
    aaco_descripcion_anterior: 'Tipo Medida Anterior',
    aama_descripcion: 'Marca',
    aamo_descripcion: 'Modelo',
    aamo_descripcion_anterior: 'Modelo Anterior',
    aacu_descripcion: 'Cuenta Alumbrado',
    tipo_descripcion: 'Poste',
    aap_poste_altura: 'Poste Altura',
    aap_poste_propietario: 'Poste Propietario',
    aap_brazo: 'Brazo',
    aap_collarin: 'Collarin',
    aap_potencia: 'Potencia',
    aap_tecnologia: 'Tecnologia',
    aap_potencia_anterior: 'Potencia Anterior',
    aap_tecnologia_anterior: 'Tecnologia Anterior',
    aap_rte: 'Reporte Técnico',
    aap_bombillo: 'Bombillo',
    aap_balasto: 'Balasto',
    aap_arrancador: 'Arrancador',
    aap_condensador: 'Condensador',
    aap_fotocelda: 'Fotocelda',
    aap_conexion: 'Tipo Medida',
    repo_fecharecepcion: 'Fecha Reporte',
    repo_fechadigitacion: 'Fecha Digitación',
    repo_descripcion: 'Descripción',
    potenciatotal: 'Potencia Total Periodo',
    graficorecibidos: 'Reportes Recibidos Por Origen',
    graficouso: 'Reportes Recibidos por SubSector',
    graficoatendidas: 'Reportes Atendidos',
    graficorecibidosvspendientes: 'Reportes por Estado',
    graficosectorrecibidos: 'Reporte por Tipo Sector',
    vereda: 'Vereda',
    parque: 'Parque',
    concreto: 'Concreto',
    metalico: 'Metálico',
    medidor: 'Medidor',
    aforo: 'Aforo',
    reubicado: 'Reubicado',
    repo_nombre: 'Persona/Entidad/Usuario',
    repo_telefono: 'Télefono',
    repo_direccion: 'Dirección',
    medio: 'Medio',
    repo_reportetecnico: 'Solución Trabajo Realizado',
    acti_descripcion: 'Actividad',
    visitas: 'Visitas',
    periodo: 'Periodo',
    anho: 'Año',
    uso: 'Uso',
    cuentaap: 'Cuenta Alumbrado',
    uso_anterior: 'Uso Anterior',
    cuentaap_anterior: 'Cuenta Alumbrado Anterior',
    tire: 'Retiro Para',
    urba_descripcion: 'Urbanizadora',
    soli_radicado: 'Radicado',
    soti_descripcion: 'Tipo Solicitud',
    soli_fecha: 'Fecha Recepción',
    soli_solicitud: 'Descripción Solicitud',
    soli_fechalimite: 'Fecha Límite',
    soli_consecutivo: 'Csc Atención',
    soli_direccion: 'Dirección',
    soli_nombre: 'Nombre Solicitante',
    soli_fecharespuesta: 'Fecha Respuesta',
    soli_fechaentrega: 'Fecha Entrega Respuesta',
    soli_informetecnico: 'Informe Técnico',
    soli_fechaalmacen: 'Fecha Programación',
    soli_codigorespuesta: 'Código Respuesta',
    soli_fecharte: 'Fecha Reporte',
    soli_numerorte: 'Puesto',
    soli_puntos: 'Puntos',
    soli_luminarias: 'Luminarias',
    soli_tipoexpansion: 'Tipo Expansión',
    soli_estado_descripcion: 'Estado',
    enbaja: 'Dada de Baja',
    medi_codigo: 'Medidor Código',
    medi_numero: 'Medidor Número',
    esta_descripcion: 'Estado',
    tran_codigo: 'Transformador Código',
    tran_numero: 'Transformador Número',
    cuad_descripcion: 'Cuadrilla',
    repo_fechalimite: 'Fecha Limite',
    luminarias: 'Luminarias',
    operaciones: 'Operaciones',
    reportes: 'Reportes',
    urbano: 'Urbano',
    rural: 'Rural',
    ortr_id: 'Orden No.',
    ortr_consecutivo: 'No. Orden Trabajo',
    ortr_fecha: 'Fecha',
    cuad_responsable: 'Responsable',
    cuad_vehiculo: 'Vehículo',
    ortr_tipo: 'Tipo(Mto/Exp)',
    ortr_dia: 'Día Semana',
    obras: 'Obras',
    obra_consecutivo: 'Nro. Obra',
    obra_fecharecepcion: 'Fecha Obra',
    repo_tipo_expansion: 'Tipo',
    siccmx: 'Consolidado de Material por Cuadrilla',
    srsf: 'Reportes Sin Registro Fotográfico',
    fotos: 'Fotos',
    processing: 'Procesando',
    elem_unidad: 'Unidad',
    tipo_operacion: 'Tipo Operación'
  },
  grafica: {
    cantidad: 'Cantidad',
    potencia: 'Potencia',
    tecnologia: 'Tecnología'
  },
  permission: {
    roles: 'Sus perfiles',
    switchRoles: 'Cambiar perfil'
  },
  components: {
    documentation: 'Documentación',
    tinymceTips:
      'Editor Rich text es parte del sistema de administración, aún presenta algunos problemas.',
    dropzoneTips:
      'Debido a que el negocio presenta necesidades especiales, y necesita subir archivos, se decidio encapsular localmente. Puede ver código detalle en @/components/Dropzone.',
    stickyTips:
      'cuando la página es desplazada a la posición actual, será pegada a la parte superior.',
    backToTopTips1:
      'Cuando la página es desplazada, el botón atrás arriba aparece en la esquina inferior derecha',
    backToTopTips2:
      'Ud puede personalizar el estilo de los botones, mostrar / ocultar, alto de apariencia, alto de retorno. Si necesita prompt de texto, puede usar element-ui el-tooltip elements externally',
    imageUploadTips: 'Subir archivos de imagen.'
  },
  table: {
    dynamicTips1: 'Encabezado Fijo, ordenado por encabezado',
    dynamicTips2: 'Encabezado dinámico, ordenado por el clic',
    dragTips1: 'Ordenado por defecto',
    dragTips2: 'Ordenado por después de arrastras',
    title: 'Título',
    importance: 'Imp',
    type: 'Tipo',
    remark: 'Remarcar',
    search: 'Buscar',
    add: 'Agregar',
    export: 'Exportar',
    reviewer: 'revisualizar',
    id: 'ID',
    date: 'Fecha',
    author: 'Autor',
    readings: 'Lecturas',
    status: 'Estado',
    actions: 'Acciones',
    edit: 'Editar',
    publish: 'Publicar',
    draft: 'Borrador',
    delete: 'Borrar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    accion: 'Acción'
  },
  errorLog: {
    tips:
      'Por favor de clic en el icono del bicho en la esquina superior derecha',
    description: '...',
    documentation: 'Documento de introducción'
  },
  excel: {
    export: 'Exportar',
    selectedExport: 'Exportar elementos seleccionados',
    placeholder: 'Por favor ingrese un nombre de archivo'
  },
  zip: {
    export: 'Exportar',
    placeholder: 'Por favor ingrese un nombre de archivo'
  },
  theme: {
    change: 'Cambiar tema',
    documentation: 'Documentación de temas',
    tips: 'Tips: Mire la documentación para mayor información.'
  },
  tagsView: {
    close: 'Cerrar',
    closeOthers: 'Cerrar Otros',
    closeAll: 'Cerrar Todo'
  },
  element: {
    select: 'Seleccionar'
  },
  orhi: {
    tabletitle: 'Orden de Trabajo Historica',
    orhi_consecutivo: 'Acta Orden No.',
    orhi_fechasolucion: 'Fecha Orden',
    orhi_objeto: 'Objeto de la Orden',
    orhi_direccion: 'Dirección de la Orden',
    orhi_barrio: 'Barrio de la Orden',
    orhi_edit: 'Actualizar Orden',
    general: 'Datos Generales',
    orhi_fecharecepcion: 'Fecha de la Orden',
    orhi_reti_id: 'Tipo de Obra',
    tipo_expansion: {
      title: 'Tipo de Expansión'
    },
    consecutivo: 'Acta Orden No.',
    barr_id: 'Barrio',
    orhi_descripcion: 'Descripción del Acta de Orden',
    orhi_material: 'Material Utilizado',
    barr_descripcion: 'Barrio',
    reti_id: 'TIpo de Obra',
    orhi_potencia_nueva: 'Potencia Nueva',
    orhi_tecnologia_nueva: 'Tecnología Nueva',
    orhi_potencia_anterior: 'Potencia Anterior',
    orhi_tecnologia_anterior: 'Tecnología Anterior',
    tipo_potencia: 'Potencia',
    tipo_tecnologia: 'Tecnologia',
    tipo: {
      select: 'Seleccione'
    }
  },
  actas: {
    flujo_caja_vigente: 'Acta Flujo De Caja Contractual Vigente',
    flujo_caja_ejecutado: 'Acta Flujo De Caja Ejecutado'
  }
}
